import { Box } from '@forgeglobal/design-framework'
import { InteractionFilter, InteractionWithRollupsDataFragment } from 'graphql/bindings/AdminBindings'
import React from 'react'

import { ConversationInfoCard } from './ConversationInfoCard'

interface InteractionListProps {
  interactions: InteractionWithRollupsDataFragment[]
  currentId: string
  isAccount?: boolean
  accountName?: string
  filter: InteractionFilter
}

const InteractionList: React.FC<InteractionListProps> = ({
  interactions,
  currentId,
  isAccount,
  accountName,
  filter,
}) => {
  const displayedInteractions = interactions.length ? (
    <Box mt={2}>
      {interactions.map(interaction => (
        <ConversationInfoCard
          key={interaction.id}
          interaction={interaction}
          currentId={currentId}
          isAccount={isAccount}
          accountName={accountName}
          groupFilter={filter}
        />
      ))}
    </Box>
  ) : null

  return displayedInteractions
}
export { InteractionList }
